export const voices = {
  'eduardo-van-der-kooy': 'Eduardo van der Kooy',  
  'ricardo-kirschbaum': 'Ricardo Kirschbaum',
  'ricardo-roa': 'Ricardo Roa',
  'santiago-fioriti': 'Santiago Fioriti',
}